import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LocalStorage } from 'ngx-webstorage';
import { UsersService } from '../../../data/users.service';
import { UserEditDialogComponent } from '../user-edit-dialog/user-edit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserRole } from 'projects/core/src/lib/login/data/user-role';

@Component({
    selector: 'app-users-filter',
    templateUrl: './users-filter.component.html',
    styleUrls: ['./users-filter.component.scss']
})
export class UsersFilterComponent implements OnInit {


    constructor(
        protected dialog: MatDialog,
        protected usersService: UsersService
    ) { }

    roles: UserRole[] = []

    @Output()
    updateRoles = new EventEmitter<string[]>();

    // @LocalStorage()
    @Input()
    selectedRoles: string[];

    showAll: boolean;

    countRoles: any;

    filterIsOn: boolean;

    ngOnInit() {
        this.getRoles();
    }

    countRolesMethod() {
        if (this.selectedRoles) {
            if (this.selectedRoles.length === this.roles.length) {
                this.filterIsOn = false;
            }
            else {
                this.countRoles = this.selectedRoles.length
                this.filterIsOn = true;
            }

            if (this.selectedRoles.length !== this.roles.length) {
                this.showAll = false;
            }
            else if (this.selectedRoles.length === this.roles.length) {
                this.showAll = true;
            }
        }
    }

    getRoles() {
        this.usersService.getRoles()
            .subscribe(roles => {
                this.roles = roles
                if (typeof this.selectedRoles === 'undefined' || this.selectedRoles === null) {
                    this.selectedRoles = this.roles.map(role => role.name).filter(role => role !== 'Admin' && role !== 'Developer' && role !== 'ShopTV' && role !== 'System');
                }
                this.updateFilteredRoles(this.selectedRoles)
                this.countRolesMethod()
            })
    }

    fillRoles() {
        this.selectedRoles = [...this.roles.map(role => role.name)]
    }

    clickOnFilter() {
        this.filter()
    }

    filter() {
        this.updateFilteredRoles(this.selectedRoles)
        this.countRolesMethod()
    }

    showAllButton() {
        if (!this.showAll) {
            this.selectedRoles = [];

            this.updateFilteredRoles([])
        }
        else if (this.showAll) {
            this.fillRoles()
            this.updateFilteredRoles(this.roles.map(role => role.name))
        }
        this.countRolesMethod();
    }

    updateFilteredRoles(roles: string[]) {
        this.updateRoles.emit(roles);
    }


}
